import { Input, Directive } from '@angular/core';
import { Unsubscribe } from './unsubscribe.class';

@Directive()
export class Tables extends Unsubscribe {
  @Input() allExpanded = false;
  @Input() expandSet: Set<number> = new Set<number>();
  @Input() tableObj: any[];
  /**
   * Expand or collapse row
   * @param id row id
   * @param checked
   */
  onExpandChange(id: number, checked: boolean): void {
    if (checked) {
      this.expandSet.add(id);
    } else {
      this.expandSet.delete(id);
    }
    this.manageExpandBtn();
  }

  /**
   * Manage collapse button display
   */
  manageExpandBtn() {
    if (this.expandSet.size === this.tableObj.length) {
      this.allExpanded = true;
    } else {
      this.allExpanded = false;
    }
  }
}
